import { baseFetchToken } from './BaseSaga'
import CategoryActions from '../Redux/CategoryRedux'
import { getToken } from '../Services/GetToken'

export function * getCategory (api, action) {
  yield baseFetchToken(
    api.getCategory,
    action.data,
    getToken,
    CategoryActions.getCategorySuccess,
    CategoryActions.getCategoryFailure
  )
}

export function * getSingleCategory (api, action) {
  yield baseFetchToken(
    api.getSingleCategory,
    action.data,
    getToken,
    CategoryActions.getSingleCategorySuccess,
    CategoryActions.getSingleCategoryFailure
  )
}

export function * createCategory (api, action) {
  yield baseFetchToken(
    api.createCategory,
    action.data,
    getToken,
    CategoryActions.createCategorySuccess,
    CategoryActions.createCategoryFailure
  )
}

export function * updateCategory (api, action) {
  yield baseFetchToken(
    api.updateCategory,
    action.data,
    getToken,
    CategoryActions.updateCategorySuccess,
    CategoryActions.updateCategoryFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/CategorySagas.js